import Modal from "../UI/Modal";
import { useSelector, useDispatch } from "react-redux";
import { closeViewModal } from "../../store/reducers/frasesRespuesta/frasesRespuesta.reducer";
import Loader from "../UI/Loader";
import Field from "../UI/Field";
import AuditInfo from "../UI/AuditInfo";

const FraseRespuestaViewModal = () => {
  const dispatch = useDispatch();

  const {
    viewModalOpen,
    selectedFraseRespuesta,
    selectedFraseRespuestaLoading,
    selectedFraseRespuestaError,
  } = useSelector((state) => state.frasesRespuesta);

  return (
    <Modal
      open={viewModalOpen}
      onClose={() => dispatch(closeViewModal())}
      title="Detalle de la frase respuesta"
      size="lg"
    >
      {selectedFraseRespuestaLoading && (
        <Loader
          center
          text="Cargando información de la frase respuesta..."
          delay={150}
          type="dots"
        />
      )}

      {selectedFraseRespuestaError && (
        <p className="text-danger">{selectedFraseRespuestaError}</p>
      )}

      {!selectedFraseRespuestaLoading && selectedFraseRespuesta && (
        <div className="row g-4">
          {/* Frase - Columna completa */}
          <div className="col-12">
            <Field
              icon="mdi:message-reply-text-outline"
              label="Frase"
              value={selectedFraseRespuesta.frase}
            />
          </div>

          {/* Información principal */}
          <div className="col-md-6">
            <Field
              icon="mdi:numeric"
              label="Valor"
              value={selectedFraseRespuesta.valor}
            />
          </div>

          <div className="col-md-6">
            <Field
              icon="mdi:package-variant"
              label="Paquete de respuesta"
              value={selectedFraseRespuesta.paquete_respuesta_nombre || "N/A"}
            />
          </div>

          <div className="col-md-6">
            <Field
              icon="mdi:toggle-switch"
              label="Estado"
              value={
                <span
                  className={`badge ${
                    selectedFraseRespuesta.is_active
                      ? "bg-success-focus text-success-main"
                      : "bg-neutral-200 text-neutral-600"
                  } px-3 py-2`}
                >
                  {selectedFraseRespuesta.is_active ? "Activo" : "Inactivo"}
                </span>
              }
            />
          </div>

          {selectedFraseRespuesta.is_neutal !== undefined && (
            <div className="col-md-6">
              <Field
                icon="mdi:scale-balance"
                label="¿Es neutral?"
                value={
                  <span
                    className={`badge ${
                      selectedFraseRespuesta.is_neutal
                        ? "bg-info-focus text-info-main"
                        : "bg-neutral-200 text-neutral-600"
                    } px-3 py-2`}
                  >
                    {selectedFraseRespuesta.is_neutal ? "Sí" : "No"}
                  </span>
                }
              />
            </div>
          )}

          {/* Información de auditoría */}
          <div className="col-12">
            <AuditInfo
              createdAt={selectedFraseRespuesta.created_at}
              updatedAt={selectedFraseRespuesta.updated_at}
              createdBy={selectedFraseRespuesta.created_by}
              updatedBy={selectedFraseRespuesta.updated_by}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default FraseRespuestaViewModal;
